import { createGlobalStyle } from 'styled-components';
import openSansB from '~/fonts/OpenSans-Bold.ttf';
import openSansEB from '~/fonts/OpenSans-ExtraBold.ttf';
import openSansL from '~/fonts/OpenSans-Light.ttf';
import openSansM from '~/fonts/OpenSans-Medium.ttf';
import openSans from '~/fonts/OpenSans-Regular.ttf';
import openSansSB from '~/fonts/OpenSans-SemiBold.ttf';

import openSansCondensedB from '~/fonts/OpenSans_Condensed-Bold.ttf';
import openSansCondensedEB from '~/fonts/OpenSans_Condensed-ExtraBold.ttf';
import openSansCondensedL from '~/fonts/OpenSans_Condensed-Light.ttf';
import openSansCondensedM from '~/fonts/OpenSans_Condensed-Medium.ttf';
import openSansCondensed from '~/fonts/OpenSans_Condensed-Regular.ttf';
import openSansCondensedSB from '~/fonts/OpenSans_Condensed-SemiBold.ttf';

export const ApplicationGlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Open Sans';
    font-display: swap;
    font-style: normal;
    font-weight: 300;
    src: local('Open Sans'), url(${openSansL})
  }

  @font-face {
    font-family: 'Open Sans';
    font-display: swap;
    font-style: normal;
    font-weight: 400;
    src: local('Open Sans'), url(${openSans})
  }

  @font-face {
    font-family: 'Open Sans';
    font-display: swap;
    font-style: normal;
    font-weight: 500;
    src: local('Open Sans'), url(${openSansM})
  }

  @font-face {
    font-family: 'Open Sans';
    font-display: swap;
    font-style: normal;
    font-weight: 600;
    src: local('Open Sans'), url(${openSansSB})
  }

  @font-face {
    font-family: 'Open Sans';
    font-display: swap;
    font-style: normal;
    font-weight: 700;
    src: local('Open Sans'), url(${openSansB})
  }

  @font-face {
    font-family: 'Open Sans';
    font-display: swap;
    font-style: normal;
    font-weight: 800;
    src: local('Open Sans'), url(${openSansEB})
  }

  @font-face {
    font-family: 'Open Sans Condensed';
    font-display: swap;
    font-style: normal;
    font-weight: 300;
    src: local('Open Sans'), url(${openSansCondensedL})
  }

  @font-face {
    font-family: 'Open Sans Condensed';
    font-display: swap;
    font-style: normal;
    font-weight: 400;
    src: local('Open Sans'), url(${openSansCondensed})
  }

  @font-face {
    font-family: 'Open Sans Condensed';
    font-display: swap;
    font-style: normal;
    font-weight: 500;
    src: local('Open Sans'), url(${openSansCondensedM})
  }

  @font-face {
    font-family: 'Open Sans Condensed';
    font-display: swap;
    font-style: normal;
    font-weight: 600;
    src: local('Open Sans'), url(${openSansCondensedSB})
  }

  @font-face {
    font-family: 'Open Sans Condensed';
    font-display: swap;
    font-style: normal;
    font-weight: 700;
    src: local('Open Sans'), url(${openSansCondensedB})
  }

  @font-face {
    font-family: 'Open Sans Condensed';
    font-display: swap;
    font-style: normal;
    font-weight: 800;
    src: local('Open Sans'), url(${openSansCondensedEB})
  }

  body {
    height: 100vh;
  }
  #app {
    display: flex;
    height: 100vh;
    overflow: hidden;
  }

  //TODO: Temp change for the demo. Remove once the changes are implemented in GDS.
  ul[id^='downshift'] li {
    height: 24px;
    padding: 12px 24px 24px 24px;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
